import styled from 'styled-components';

export const UserIcon = styled.img`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
  outline: none;
  margin-right: 5px;
`;



// WEBPACK FOOTER //
// ./src/components/notes-simple-list/meeting-notes-list-item/meeting-participants-feedbacks/participants-list/participant/styles.js